import { render, staticRenderFns } from "./TGBInvoiceAudit.vue?vue&type=template&id=5a7fef86&"
import script from "./TGBInvoiceAudit.vue?vue&type=script&lang=js&"
export * from "./TGBInvoiceAudit.vue?vue&type=script&lang=js&"
import style0 from "./TGBInvoiceAudit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports